// Core packages
import { NgModule } from "@angular/core";

// Third party packages

// Custom packages - Modules
import { SharedModule } from "src/app/modules/shared.module";

// Custom packages - Components
import { DocumentArchiveDossierDialogComponent } from "src/app/modules/properties/components/document-archive-dossier-dialog/document-archive-dossier-dialog.component";

/**
 * The dialog that downloads the dossier zip of a property from the 3.0.0 archive, one part at a time
 * (NEW-M17).
 *
 * Imported by PropertiesModule. The buttons that open it — «Scarica archivio fascicolo documentale» of
 * the property home and «Esporta file» of the property lists and of the statistics — are on pages of
 * PropertiesModule and StatsModule, both in AppModule, and before Ivy a dialog is resolved by the
 * injector of the module that opens it or by the root one. That puts it in the initial bundle, as the
 * legacy dialog it stands in for.
 *
 * @since 3.0.0
 */
@NgModule({
  imports: [SharedModule],
  declarations: [DocumentArchiveDossierDialogComponent],
  entryComponents: [
    // Pre-Ivy requirement: the dialog is created at runtime by MatDialog
    DocumentArchiveDossierDialogComponent,
  ],
})
export class DocumentArchiveDossierDialogModule {}
